// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__8R5CN","label":"SetPasswdForm_label__2O-d0"};